import { FormControlLabel, Checkbox as MuiCheckbox } from '@mui/material';
import HelpTooltip from '../HelpTooltip';
import { BiHelpCircle } from 'react-icons/bi';
import FieldLock from '../FieldLock';

export interface CheckboxProps {
    checked: boolean;
    onChange: (value: boolean) => void;
    labelText: string;
    labelId: string;
    mandatory: boolean;
    helpTextTitle: string;
    helpTextBody: string;
    disabled: boolean;

    onLock: (field: string, locked: boolean) => void;
    disabledLock: boolean;
    displayedLock: boolean;
    isLocked: boolean;
}

const FBCheckbox = (props: CheckboxProps): JSX.Element => {

    return (
        <FormControlLabel
        sx={{ fontSize: '12px', whiteSpace: 'nowrap' }}
        control={
          <MuiCheckbox
            id={props.labelId}
            data-testid={props.labelId}
            checked={props.checked}
            sx={{
              '& .MuiSvgIcon-root': {
                backgroundColor: '#FFFFFF',
                borderRadius: '4px',
              },
            }}
            onChange={(event) => props.onChange(event.target.checked)}
          />
        }
        label={
            <span style={{ marginLeft: '4px', fontSize: '12px' }}>
            <FieldLock
                onChange={function (locked: boolean): void {
                    props.onLock(props.labelId,locked);
                } }
                labelId={props.labelId}
                disabled={props.disabledLock}
                displayed={props.displayedLock}
                value={props.isLocked}/>
            {props.labelText} {props.mandatory && <b>* </b>}
            <span style={{ display: 'inline-block' }}>
            <HelpTooltip title={props.helpTextTitle} body={props.helpTextBody}> <BiHelpCircle /> </HelpTooltip>
            </span>
        </span>
        }
        disabled={props.disabled}
      />

    );
  };

export default FBCheckbox;